/*
 * Trafford product buy + bracelet upsell. On the watch PDP:
 *  - toggling the "Add Metal Bracelet" checkbox updates the displayed total
 *    (watch price <-> watch + bracelet) and swaps the hero render from the
 *    strap version to the bracelet version (GSAP fade),
 *  - Add to cart submits watch + bracelet as two line items via /cart/add.js.
 * No-op / graceful when pieces are missing (e.g. no bracelet render set yet).
 */
(function () {
  function initPdp(root) {
    if (root.dataset.buyInit === '1') return;
    root.dataset.buyInit = '1';

    var addon = root.querySelector('[data-twc-addon]');
    var priceBase = root.querySelector('[data-twc-price-base]');
    var priceCombined = root.querySelector('[data-twc-price-combined]');
    var media = root.querySelector('[data-twc-hero-media]');
    var img = media && media.querySelector('.twc-pdp__hero-img');
    var strapSrc = media && media.getAttribute('data-twc-strap-src');
    var braceletSrc = media && media.getAttribute('data-twc-bracelet-src');

    function swapImage(toBracelet) {
      if (!img || !braceletSrc) return;
      var target = toBracelet ? braceletSrc : strapSrc;
      if (!target || img.getAttribute('src') === target) return;
      function set() { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = target; }
      if (window.gsap) {
        window.gsap.to(img, { opacity: 0, duration: 0.15, ease: 'power1.out', onComplete: function () {
          set();
          window.gsap.fromTo(img, { opacity: 0 }, { opacity: 1, duration: 0.22, ease: 'power1.out' });
        } });
      } else { set(); }
    }

    var note = root.querySelector('[data-twc-note]');
    var buyPrice = root.querySelector('[data-twc-buy-price]');
    function apply(checked) {
      if (priceBase && priceCombined) {
        priceBase.hidden = checked;
        priceCombined.hidden = !checked;
      }
      // buy-button price (the only price visible on mobile) mirrors the same toggle
      if (buyPrice) {
        var base = buyPrice.getAttribute('data-price-base');
        var combined = buyPrice.getAttribute('data-price-combined');
        if (base && combined) buyPrice.textContent = checked ? combined : base;
      }
      if (note) {
        var t = checked ? note.getAttribute('data-note-on') : note.getAttribute('data-note-off');
        if (t) note.innerHTML = t;
      }
      // swap hero render leather <-> bracelet. Self-guards: no-op unless the product
      // has a bracelet_render (data-twc-bracelet-src). So only Core (which has one) swaps.
      swapImage(checked);
    }

    if (addon) addon.addEventListener('change', function () { apply(addon.checked); });

    var form = root.querySelector('[data-twc-buyform]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // One per order (product tagged limit-1, e.g. a numbered drop): if this watch is
        // already in the cart, show the cart instead of adding a second.
        if (form.hasAttribute('data-twc-limit-one') && !form.dataset.twcLimitChecked) {
          var vid = form.getAttribute('data-twc-variant');
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var has = cart.items.some(function (i) { return String(i.variant_id) === String(vid); });
              var drawer = document.querySelector('cart-drawer-component');
              if (has && drawer && drawer.open) { drawer.open(); return; }
              if (has) { window.location.href = '/cart'; return; }
              form.dataset.twcLimitChecked = '1';
              form.requestSubmit();
            })
            .catch(function () { form.dataset.twcLimitChecked = '1'; form.requestSubmit(); });
          return;
        }
        delete form.dataset.twcLimitChecked;
        var items = [{ id: form.getAttribute('data-twc-variant'), quantity: 1 }];
        if (addon && addon.checked && addon.value) {
          items.push({ id: addon.value, quantity: 1, properties: { _addon: 'bracelet' } });
        }
        var btn = form.querySelector('button');
        if (btn) btn.disabled = true;
        function done() { if (btn) btn.disabled = false; }
        // Preferred path: route through Horizon's native cart (opens the drawer).
        if (window.traffordAddToCart) {
          window.traffordAddToCart(items, { sourceId: 'twc-watch' }).then(done).catch(done);
          return;
        }
        // Fallback if the helper module hasn't loaded: native add + redirect.
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(done);
      });
    }
  }

  function initAll(rootEl) {
    (rootEl || document).querySelectorAll('[data-twc-pdp]').forEach(initPdp);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
